var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('hb-form',{attrs:{"label":"Pin Length"}},[_vm._v(" "+_vm._s(_vm.connection.Credentials.pin_format)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }